module.exports = __webpack_public_path__ + "static/media/createRole.9fb510a9.svg";